import apiService from "./apiServices";

export const uploadFolderFiles = async (formData, token) => {
    try {
        const response = await apiService('/attachment/upload-files', 'POST', formData, undefined, token);
        return response;
    } catch (error) {
        throw new Error(error?.message || 'Upload Folder failed. Please try again.');
    }
};


export const createFolderFiles = async (formData, token) => {
    try {

      const response = await apiService('/attachment/create-folder', 'POST', formData, null, token);
      return response;
    } catch (error) {
      throw new Error(error?.message || 'Create Folder failed. Please try again.');
    }
  };


  export const getAllFolderFiles = async (policyId, page, size, token) => {
    try {
      if (!policyId) throw new Error("policyId is required to fetch folder files.");

      const response = await apiService(
        `/attachment/folders/root/policy/${policyId}?page=${page}&size=${size}`,
        'GET',
        null,
        null,
        token
      );

      return response;
    } catch (error) {
      throw new Error(error?.message || 'Get All Folder Files service failed. Please try again.');
    }
  };
  export const getAllFolderFilesCustomer = async (clientCustomerId, page, size, token) => {
    try {

      const response = await apiService(
        `/attachment/folders/root/client-customer/${clientCustomerId}?page=${page}&size=${size}`,
        'GET',
        null,
        null,
        token
      );

      return response;
    } catch (error) {
      throw new Error(error?.message || 'Get All Folder Files service failed. Please try again.');
    }
  };


  export const getFolderFilesService = async (folderId,token,page,size) => {
    try {
      const response = await apiService(
        `/attachment/get-folder?folderId=${folderId}&page=${page}&size=${size}&sort=desc`,
        'GET',
        null,
        folderId,
        token
      );

      return response;
    } catch (error) {
      throw new Error(error?.message || 'Get Folder Files service failed. Please try again.');
    }
  };

  export const getFilesDownloadService = async (id, token, download = false) => {
    try {
      const response = await apiService(
        `/attachment/get/${id}?download=${download}`,
        'GET',
        null,
        id,
        token
      );
  
      return response;
    } catch (error) {
      throw new Error(error?.message || 'Get Folder Files service failed. Please try again.');
    }
  };
  


  export const deleteFolderFiles = async (folderId, policyId, folderPath, token) => {
    try {
      if (!folderId || !policyId || !folderPath) {
        throw new Error("folderId, policyId, and folderPath are required to delete folder files.");
      }

      const queryParams = `?id=${folderId}&policyId=${policyId}&folderPath=${encodeURIComponent(folderPath)}`;
      const response = await apiService(`/attachment/delete${queryParams}`, 'DELETE', undefined, undefined, token);

      return response;
    } catch (error) {
      throw new Error(error?.message || 'Delete Folder Files service failed. Please try again.');
    }
  };

  export const deleteFolderFilesCustomer = async (folderId, customerId, folderPath, token) => {
    try {

      const queryParams = `?id=${folderId}&clientCustomerId=${customerId}&folderPath=${encodeURIComponent(folderPath)}`;
      const response = await apiService(`/attachment/delete${queryParams}`, 'DELETE', undefined, undefined, token);

      return response;
    } catch (error) {
      throw new Error(error?.message || 'Delete Folder Files service failed. Please try again.');
    }
  };